<template>
  <div>
    <img src="../../assets/wxUser/top.jpg" class="topImg" />
    <div class="word1">
      当前地区：{{ LocationProvince }}{{ LocationCity }}{{ LocationArea }}
    </div>
    <van-empty description="" v-if="list.length == 0" />
    <div class="list" v-for="item in list" :key="item.id">
      <div class="listChild">
        <img src="../../assets/wxUser/lIcon1.png" />
        <p>名称</p>
        <div>{{ item.cName }}</div>
      </div>
      <div class="listChild">
        <img src="../../assets/wxUser/lIcon3.png" />
        <p>联系电话</p>
        <div>{{ item.cMobile }}</div>
      </div>
       <div class="listChild">
        <img src="../../assets/wxUser/lIcon2.png" />
        <p>省市区</p>
        <div>{{ item.cProvince }}{{ item.cCity }}{{ item.cCounty }}</div>
      </div>
      <div class="listChild">
        <img src="../../assets/wxUser/lIcon2.png" />
        <p>详细地址</p>
        <div>{{ item.cAddress }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Empty } from "vant";

export default {
  data() {
    return {
      list: [],
      LocationProvince: "",
      LocationCity: "",
      LocationArea: "",
    };
  },
  components: {
    [Toast.name]: Toast,
    [Empty.name]: Empty,
  },
  methods: {
    getList() {
      var _this=this;
      var dd = {
        cProvince: this.LocationProvince.replace(/省/, ""),
        cCity: this.LocationCity.replace(/市/, ""),
        cCounty: this.LocationArea,
        page:1,
        limit:100,
        cName:"",
        cMobile:"",
        order:""
      };
      this.$get("/api/AfterSaleAPI/GetAfterSaleInfoListForMobile", dd)
        .then((res) => {
          _this.list=res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    
  },
  created() {
    /* global BMap*/
    var dd = {
      url: location.href.split("#")[0],
    };
    var _this = this;
    this.$get("/WechatOAuthAPI/WechatSign", dd)
      .then((res) => {
        if (!res.IsError) {
          _this.wx.config({
            debug: false,
            appId: res.Data.AppId,
            timestamp: res.Data.Timestamp,
            nonceStr: res.Data.NonceStr,
            signature: res.Data.Signature,
            jsApiList: ["scanQRCode", "getLocation"],
          });
          _this.wx.ready(function () {
            _this.wx.getLocation({
              type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
              success: function (res) {
                console.log(res);
                let x_PI = (3.14159265358979324 * 3000.0) / 180.0;
                var lat = Number(res.latitude);
                var lng = Number(res.longitude);
                var z =
                  Math.sqrt(lng * lng + lat * lat) +
                  0.00002 * Math.sin(lat * x_PI);
                var theta =
                  Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
                lng = z * Math.cos(theta) + 0.0065;
                lat = z * Math.sin(theta) + 0.006;
                let point = new BMap.Point(lng, lat);
                let gc = new BMap.Geocoder();
                gc.getLocation(point, function (rs) {
                  console.log(rs);
                  let addComp = rs.addressComponents;
                  _this.LocationProvince = addComp.province;
                  _this.LocationCity = addComp.city;
                  _this.LocationArea = addComp.district;
                  _this.getList();
                });

              },
              cancel: function () {
                Toast(
                  "您好！由于您拒绝获取地理位置,无法获取相应地区的经销商信息"
                );
              },
            });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style scoped>
.topImg {
  width: 375px;
}
.list {
  width: 348px;

  background-color: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.48);
  border-radius: 10px;
  margin: 16px auto;
  padding: 10px 0;
}
.listChild {
  display: flex;
  font-size: 13px;
  align-items: center;
  margin: 10px;
}
.listChild img {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  margin-right: 10px;
}
.listChild p {
  flex-shrink: 0;
  width: 70px;
  text-align: left;
}
.listChild div {
  width: 100%;
  text-align: left;
}
.word1 {
  font-size: 12px;
  color: #999999;
}
</style>
